import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function VolumeMuteIcon({ height = 60, width = 60, color = 'white' }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g fill={color}>
        <path d="m11.1925 4.42855c.3608-.45067 1.1075-.19944 1.1075.37793v14.39532c-.0002.5765-.7448.8274-1.1051.3773-.6022-.752-1.33621-1.6308-1.89495-2.1791-1.19954-1.1771-2.99085-2.2445-3-2.25h-3c-.33128 0-.59986-.2681-.6-.5994v-5.10116c.00006-.33132.26866-.59941.6-.59941h3s1.81682-1.0935 3-2.25c.56796-.55516 1.29605-1.42566 1.89255-2.17148z" />
        <path d="m21.4775 8.87757-3.1225 3.12243 3.1225 3.1225-.9551.9551-3.1224-3.1225-3.1225 3.1225-.9551-.9551 3.1225-3.1225-3.1225-3.12243.9551-.95508 3.1225 3.12251 3.1224-3.12251z" />
      </g>
    </SVGWrapper>
  );
}
export default VolumeMuteIcon;
